import angular from 'angular';
import slugifier from 'angular-slugify';

/**
 * @memberOf cms.input.slug
 * @property {object}   bindings.errors         Form errors object
 * @property {string}   bindings.title          Input title and/or placeholder
 * @property {string}   bindings.model          Input value reference
 * @property {function} bindings.slugValidation Function that returns promise if slug is valid
 * @property {string}   bindings.slugSource     Input value reference
 */
let cmsInputSlug = {
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        model: '=',
        slugValidation: '&',
        slugSource: '<',
        disabled: '<',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        maxlength: '@'
    },
    template: require('./slug.html'),
    controller: function($scope, Slug) {

        /** @ngInclude */
        this.$onInit = () => {

            this.refreshPending = false;

            /**
             * Refresh request from outside control
             */
            $scope.$on('slug.recalc', () => {
                this.refreshSlug();
            });

            /**
             * Refresh action accessible from 'refresh' arrows
             */
            this.refreshSlug = function() {
                if(this.aclDisable) {
                    return;
                }
                this.model = this.slugSource;
                this.onBlur()
            };

            /**
             * Remember previous input value
             * to prevent re-validating same values
             */
            this.copyTmpModel = function() {
                this.previousModel = angular.copy(this.model);
            };

            this.modelChanged = function() {
                return this.previousModel !== this.model;
            };

            this.onBlur = function () {
                if(this.modelChanged()) {
                    this.model = Slug.slugify(this.model);
                    if (this.slugValidation) {
                        this.refreshPending = true;
                        this.slugValidation({data: this.model}).then(() => {
                            this.refreshPending = false;
                        });
                    }
                }
                this.copyTmpModel();
            };
        }
    }
};

/**
 * Slug control
 * @namespace cms.input.slug
 */
export default angular.module('cms.input.slug', ['slugifier']).component('cmsInputSlug', cmsInputSlug).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Controls/SlugControl/CmsInputSlug.js